/* istanbul ignore file */
import {
  isNullLocation, getAddressComponentFromLatLong
} from './utils';
import { getLocation } from '../call-my-jio';
import { logError } from '../utils';
import { putInStorage } from './location-from-storage';

// const timeout = (ms, payload) => new Promise(resolve => setTimeout(() => {
//   resolve(payload);
// }, ms));

// const mockGetLocation = () => new Promise(resolve => {
//   setTimeout(() => {
//     resolve({
//       latitude: '48.8583701',
//       longitude: '2.2922926'
//     });
//   }, 1000);
// });

// const mock = () => Promise.race([mockGetLocation(), timeout(3000, { latitude: null, longitude: null })]);

export const getNaitveLatLong = async () => {
  const locationObj = await getLocation();
  putInStorage(locationObj);
  return locationObj;
};

export const getLocationFromNative = async () => {
  try {
    const locationObj = await getLocation();
    //console.log('i am native!!!', locationObj);
    if (isNullLocation(locationObj)) {
      return {
        latitude: '',
        longitude: '',
        add: '',
        pincode: '',
        city: '',
        state: '',
        street: '',
        district: ''
      };
    }
    const address = await getAddressComponentFromLatLong(locationObj.latitude, locationObj.longitude);
    putInStorage(address);
    return {
      ...address
    };
  } catch (e) {
    logError(e);
    return {
      latitude: '',
      longitude: '',
      add: '',
      pincode: '',
      city: '',
      state: '',
      street: '',
      district: ''
    };
  }
};
